/* eslint-disable camelcase */
import React from 'react'
import { bool, func, shape } from 'prop-types'
import { Link } from 'react-router-dom'

import { FormattedDate, FormattedTime } from 'react-intl'
import { mapContextToFilter } from 'crm-modules/dashboard/dashboard-utils'
import { qlqGenericDataQuery } from 'crm-data/generic-data'
import { CrmModal } from 'crm-components'
import genericTableFactory from 'crm-components/ql/table/crm-generic-ql-table.jsx'

const columns = [
  {
    Header: 'Account Name',
    Cell: row => (
      <Link to={'/crm/account/' + row.original.account_uid} target="blank">
        {row.original.account__name}
      </Link>
    ),
    accessor: 'account_name'
  },
  {
    Header: 'Date Completed',
    accessor: 'process_completed_time',
    Cell: row =>
      row.original.process_completed_time ? (
        <span>
          <FormattedDate value={row.original.process_completed_time} />{' '}
          <FormattedTime value={row.original.process_completed_time} />
        </span>
      ) : (
        <span />
      )
  },
  {
    Header: 'Result',
    accessor: 'step__type__name'
  },
  {
    Header: 'Owner',
    accessor: 'account__owner__full_name'
  },
  {
    Header: 'Lead Campaign',
    accessor: 'account__lead_campaign__name'
  },
  {
    Header: 'Lead In Date',
    accessor: 'account__lead_in_date',
    Cell: row =>
      row.original.account__lead_in_date ? (
        <span>
          <FormattedDate value={row.original.account__lead_in_date} />{' '}
          <FormattedTime value={row.original.account__lead_in_date} />
        </span>
      ) : (
        <span />
      )
  }
]
const qlOptions = {
  options: ownProps => {
    console.log('qlOtions, ', ownProps)
    const props = { analyticsContext: { filters: ownProps.filters } }
    const filter = { ...ownProps.filters, ...mapContextToFilter(props) }

    return {
      variables: {
        filter,
        fields: [
          'account_uid',
          'account__name',
          'process_completed_time',
          'step__type__name',
          'account__owner__full_name',
          'account__lead_campaign__name',
          'account__lead_in_date'
        ],
        rootType: 'DialerCampaignAccountsQM'
      }
    }
  },
  props: ({ tableDataQl, ownProps }) => ({
    ...ownProps,
    tableDataQl,
    tableData: tableDataQl ? tableDataQl.genericDataQuery : []
  }),
  fetchPolicy: 'no-cache'
}

const Table = genericTableFactory({
  query: qlqGenericDataQuery,
  qlOptions
})

class LeadsDetailsPopup extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return (
      <CrmModal
        isOpen={this.props.isOpen}
        title="Leads Details"
        onClose={this.props.onClose}
        size="xl"
      >
        <Table
          columns={columns}
          style={{ width: '100%' }}
          filters={this.props.filters}
          bulkOperationElementType="process"
        />
      </CrmModal>
    )
  }
}

LeadsDetailsPopup.propTypes = {
  isOpen: bool,
  onClose: func,
  filters: shape({})
}
LeadsDetailsPopup.defaultProps = {
  isOpen: false,
  onClose: () => {},
  filters: undefined
}

export default LeadsDetailsPopup
